import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PaginatedResponse } from '../../../shared/interfaces/pagination';
import { OutreachLink } from '../models/outreach-link';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PublicLinkService {
  private adminApiBaseUrl = environment.apiBaseUrl + '/api/admin';
  private http: HttpClient = inject(HttpClient);

  getAllPublicOutreachLinks(
    pageNo = 1,
    pageSize = 10,
    search?: string,
    filterBy?: string,
    connectionId?: string,
  ): Observable<PaginatedResponse<OutreachLink>> {
    let params = new HttpParams();
    params = params.set('page', pageNo.toString());
    params = params.set('page_size', pageSize.toString());

    if (connectionId) {
      params = params.set('connection', connectionId);
    }

    if (search) {
      params = params.set('name', search);
    }

    if (filterBy && filterBy !== 'all') {
      params = params.set('is_active', filterBy);
    }

    return this.http.get<PaginatedResponse<OutreachLink>>(
      this.adminApiBaseUrl + '/public-links',
      { params },
    );
  }

  createOutreachLink(
    name: string,
    meta_data: Record<string, string>,
    submission_visibility: number,
  ): Observable<OutreachLink> {
    return this.http.post<OutreachLink>(
      `${this.adminApiBaseUrl}/public-links`,
      {
        name,
        meta_data,
        submission_visibility,
      },
    );
  }

  getOutreachLinkById(id: number): Observable<OutreachLink> {
    return this.http.get<OutreachLink>(
      `${this.adminApiBaseUrl}/public-links/${id}`,
    );
  }

  deleteOutreachLink(id: number): Observable<void> {
    return this.http.delete<void>(`${this.adminApiBaseUrl}/public-links/${id}`);
  }

  UpdateOutreachLink(
    id: number,
    name?: string,
    is_active?: boolean,
    submission_visibility?: number,
  ): Observable<void> {
    const body: {
      name?: string;
      is_active?: boolean;
      submission_visibility?: number;
    } = {};
    if (name) {
      body.name = name;
    }
    if (is_active !== undefined) {
      body.is_active = is_active;
    }
    if (submission_visibility) {
      body.submission_visibility = submission_visibility;
    }
    return this.http.patch<void>(
      `${this.adminApiBaseUrl}/public-links/${id}`,
      body,
    );
  }

  redirectPublicLink(
    unique_id: string,
    access_type: string,
  ): Observable<string> {
    return this.http.get<string>(
      `${this.adminApiBaseUrl}/public-links/${unique_id}/redirect?access_type=${access_type}`,
    );
  }
}
